import api from '../utils/api';

export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const ASSIGN_TEACHER_SUCCESS = 'ASSIGN_TEACHER_SUCCESS';
export const UNASSIGN_TEACHER_SUCCESS = 'UNASSIGN_TEACHER_SUCCESS';
export const FETCH_TEACHERS_BY_GROUP_SUCCESS = 'FETCH_TEACHERS_BY_GROUP_SUCCESS';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const FETCH_GROUP_BY_ID_SUCCESS = 'FETCH_GROUP_BY_ID_SUCCESS';

export const fetchGroups = () => async (dispatch) => {
  try {
    const res = await api.get('/groups');
    dispatch({
      type: FETCH_GROUPS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching groups:', error);
  }
};

export const addGroup = (groupData) => async (dispatch) => {
  try {
    const res = await api.post('/groups', groupData);
    dispatch({
      type: ADD_GROUP_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error adding group:', error);
  }
};

export const assignTeacherToGroup = (group_id, user_id) => async (dispatch) => {
  try {
    const res = await api.post('/groups/assign-teacher', { group_id, user_id });
    dispatch({
      type: ASSIGN_TEACHER_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error assigning teacher:', error);
  }
};

export const unassignTeacherFromGroup = (group_id, user_id) => async (dispatch) => {
  try {
    await api.delete(`/groups/${group_id}/teachers/${user_id}`);
    dispatch({
      type: UNASSIGN_TEACHER_SUCCESS,
      payload: { group_id, user_id },
    });
  } catch (error) {
    console.error('Error unassigning teacher:', error);
  }
};

export const fetchTeachersByGroup = (group_id) => async (dispatch) => {
  try {
    const res = await api.get(`/groups/${group_id}/teachers`);
    dispatch({
      type: FETCH_TEACHERS_BY_GROUP_SUCCESS,
      payload: { group_id, teachers: res.data },
    });
  } catch (error) {
    console.error('Error fetching teachers by group:', error);
  }
};

export const updateGroup = (group_id, updatedGroupData) => async (dispatch) => {
  try {
    const res = await api.put(`/groups/${group_id}`, updatedGroupData);
    dispatch({
      type: UPDATE_GROUP_SUCCESS,
      payload: res.data, // Assuming the API returns the updated group object
    });
  } catch (error) {
    console.error('Error updating group:', error);
  }
};

export const fetchGroupById = (group_id) => async (dispatch) => {
  try {
    const res = await api.get(`/groups/${group_id}`);
    dispatch({
      type: FETCH_GROUP_BY_ID_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching group by ID:', error);
    // Handle error appropriately
  }
};